import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-modal', 'accept', 'Taip');
Labels.set('ui-modal', 'decline', 'Ne');
Labels.set('ui-modal', 'dismiss', 'Gerai');
Labels.set('ui-modal', 'close', 'Uždaryti iššokantį langą');
Labels.set('ui-modal', 'back', 'Atgal');
Labels.set('ui-modal', 'opened', 'Iššokantis langas atidarytas');
